<template>
  <el-form
    :model="form"
    ref="form">
    <!-- content -->
    <div class="row">
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('invoice-type')"
          prop="invoiceTypeID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-response
            :model.sync="form.invoiceTypeID"
            @on-change="autoSave('invoiceTypeID', { rules: getValidationRule('required') })"
            :isLoading="dataSourceInvoiceType.loading"
            :data="dataSourceInvoiceType.records"
          />
        </el-form-item>
      </div>
      <div class="col-lg-6 col-sm-6 col-12">
        <el-form-item
          :label="L10n('invoice-number')"
          prop="invoiceNumber"
          class="material-style"
          :rules="rulesInvoice"
        >
          <el-input
            :value="form.invoiceNumber"
            @input="form.invoiceNumber = valueTrimLeft($event)"
            @change="autoSave('invoiceNumber', { rules: rulesInvoice })"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('invoice-date')"
          prop="invoiceDate"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <date-picker
            v-model="form.invoiceDate"
            @change="autoSave('invoiceDate', { rules: getValidationRule('required') })"
          />
        </el-form-item>
      </div>

      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('po')"
          prop="po"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            :value="form.po"
            disabled
          />
        </el-form-item>
      </div>
      <div class="col-lg-6 col-sm-12 col-12">
        <el-form-item
          :label="L10n('rfq-id')"
          prop="rfqid"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-rfq
            :model.sync="form.rfqid"
            disabled
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('invoice-due-date')"
          prop="dueDate"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <date-picker
            v-model="form.dueDate"
            @change="autoSave('dueDate', { rules: getValidationRule('required') })"
          />
        </el-form-item>
      </div>

      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('vat')"
          prop="vatid"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-response
            :model.sync="form.vatid"
            @on-change="autoSave('vatid', { required: true })"
            :fields="{id: 'id', title: 'country'}"
            :isLoading="dataSourceVAT.loading"
            :data="dataSourceVAT.records"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-4 col-12">
        <el-form-item
          :label="L10n('bank-fees')"
          prop="bankFees"
          class="material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.bankFees"
            @input="form.bankFees = valueNumber($event)"
            @change="autoSave('bankFees')"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-4 col-12">
        <el-form-item
          :label="L10n('aog-charge')"
          prop="aogCharges"
          class="material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.aogCharges"
            @input="form.aogCharges = valueNumber($event)"
            @change="autoSave('aogCharges')"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-4 col-12">
        <el-form-item
          :label="L10n('shipping-charges')"
          prop="shippingCharges"
          class="material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.shippingCharges"
            @input="form.shippingCharges = valueNumber($event)"
            @change="autoSave('shippingCharges')"
          />
        </el-form-item>
      </div>

      <div class="col-12">
        <el-form-item
          :label="L10n('remark')"
          prop="remark"
          class="material-style"
        >
          <el-input
            :value="form.remark"
            type="textarea"
            @input="form.remark = valueTrimLeft($event)"
            @change="autoSave('remark')"
          />
        </el-form-item>
      </div>

      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('awb')"
          prop="awb"
          class="material-style"
        >
          <el-input
            :value="form.awb"
            @input="form.awb = valueTrimLeft($event)"
            @change="autoSave('awb')"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('ship-date')"
          prop="shipDate"
          class="material-style"
        >
          <date-picker
            v-model="form.shipDate"
            @change="autoSave('shipDate')"
          />
        </el-form-item>
      </div>
      <div class="col-lg-2 col-sm-4 col-12">
        <el-form-item
          :label="L10n('country-origin')"
          prop="countryOriginID"
          class="material-style">
          <select-response
            :model.sync="form.countryOriginID"
            @on-change="autoSave('countryOriginID')"
            :isLoading="dataSourceCountryOrigin.loading"
            :data="dataSourceCountryOrigin.records"
          />
        </el-form-item>
      </div>
      <div class="col-lg-2 col-sm-4 col-12">
        <el-form-item
          :label="L10n('total-packages')"
          prop="totalPackages"
          class="material-style"
          :rules="getValidationRule('numberInteger')"
        >
          <el-input
            :value="form.totalPackages"
            @input="form.totalPackages = valueNumber($event)"
            @change="autoSave('totalPackages')"
          />
        </el-form-item>
      </div>
      <div class="col-lg-2 col-sm-4 col-12">
        <el-form-item
          :label="L10n('flight-details')"
          prop="flightDetails"
          class="material-style"
        >
          <el-input
            :value="form.flightDetails"
            @input="form.flightDetails = valueTrimLeft($event)"
            @change="autoSave('flightDetails')"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { vatsDataSourceConverter } from '@/utils/shared'
import { ServiceInvoice } from '@/services/Invoice'

export default {
  name: 'FormCustomerPOInvoice',
  mixins: [Form],
  components: {
    'select-rfq': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectRFQ/Index.vue')
  },
  computed: {
    rulesInvoice () {
      return [
        ...this.getValidationRule('required,maxLength50'),
        {
          trigger: 'submit',
          validator: async (rule, invoiceNumber, cb) => {
            try {
              const result = await ServiceInvoice.checkUniqueInvoiceNumber({ invoiceNumber })
              if (result) {
                cb()
              } else {
                cb(new Error(this.L10n('error-invoice-exist')))
              }
            } catch (e) {
              this.requestErrorHandler(e)
            }
          }
        }
      ]
    },
    dataSourceInvoiceSource () {
      return this.API('InvoiceSources/GetAllDynamic?Select=id,title&OrderBy=title')
    },
    dataSourceInvoiceType () {
      return this.API('InvoiceTypes/GetAllDynamic?Select=id,title&OrderBy=title')
    },
    dataSourceCountryOrigin () {
      return this.API('CountryOrigins/GetAllDynamic?Select=id,title&OrderBy=title')
    },
    dataSourceVAT () {
      return vatsDataSourceConverter(this.API('VATs/GetAllDynamic?Select=id,country&OrderBy=country'))
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    dataSourceMethod () {
      return this.API('Methods/GetAllDynamic?select=id,title')
    }
  }
}
</script>
